// Dependencies
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { stringInputSpec, stringSelectSpec } from '../../lib/editing-configs';
import { Auth0Buttons } from '../auth0-buttons/auth0-buttons';

const TwoColCreateAccount = ({ trkParams, redirectUrl }) => {
  return (
    <Auth0Buttons.Container loginTrkLocation={trkParams}>
      <Auth0Buttons.AppleButton redirectTo={redirectUrl} />
      <Auth0Buttons.GoogleButton redirectTo={redirectUrl} />
      <Auth0Buttons.EmailLink redirectTo={redirectUrl} />
      <Auth0Buttons.LegalLinks />
    </Auth0Buttons.Container>
  );
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.propTypes = {
  className: PropTypes.string,
  flow: PropTypes.string,
  redirectUrl: PropTypes.string,
  identity: PropTypes.object,
  trkParams: PropTypes.object,
  size: PropTypes.oneOf(['', 'sm', 'md', 'lg']),
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.defaultProps = {
  flow: 'basic',
  trkParams: {},
};

TwoColCreateAccount.getEditingConfig = () => [
  stringSelectSpec('flow', 'Flow ID', [
    { label: 'Basic', value: 'basic' },
    { label: 'Credit Score', value: 'credit-score' },
  ]),
  stringInputSpec('redirectUrl', 'Auth Success Redirect URL'),
];

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
TwoColCreateAccount.displayName = 'TwoColCreateAccount';

export default connect(({ identity }) => ({
  identity,
}))(TwoColCreateAccount);
